export default "__VITE_ASSET__CgwMUajz__"